module.exports = __webpack_public_path__ + "img/eventPosLogo.d5635609.png";